import { ReactElement } from 'react';
import { useRoutes, useAwsGetter } from '@localstack/services';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Button } from '@mui/material';
import { LambdaCapacityProviderDetails, PageTitle } from '@localstack/ui';
import { DEFAULT_LAMBDA_ROUTES } from '@localstack/constants';

import { CapacityProviderTabs } from './components/CapacityProviderTabs';

import { LambdaProps } from './types';

export const LambdaCapacityProvider = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_LAMBDA_ROUTES,
}: LambdaProps): ReactElement => {
  const { goto } = useRoutes();
  const { name } = useParams<'name'>();

  const { data: capacityProvider } = useAwsGetter('Lambda', 'getCapacityProvider', [{ CapacityProviderName: name }], {
    clientOverrides,
  });

  return (
    <Layout
      documentTitle="Lambda: Capacity Provider Details"
      tabs={<CapacityProviderTabs routes={routes} capacityProviderName={name} />}
      title={
        <PageTitle
          title="Capacity Provider Details"
          breadcrumbs={[
            ['Lambda', () => goto(routes.RESOURCES_LAMBDA)],
            ['Capacity Providers', () => goto(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDERS)],
            [name, null],
          ]}
        />
      }
      actions={
        <Button variant="outlined" onClick={() => goto(routes.RESOURCES_LAMBDA_CAPACITY_PROVIDER_UPDATE, { name })}>
          Edit
        </Button>
      }
    >
      <Card>
        <CardContent>
          <LambdaCapacityProviderDetails data={capacityProvider?.CapacityProvider} />
        </CardContent>
      </Card>
    </Layout>
  );
};
